<!-- Dialog: Fill Now -->
<div class="blotter-dialog-container fill-now-dialog">
  <div class="blotter-dialog-form">
    <div
      [ngClass]="{
      'bfx-radiogroup-vertical-bold-sm': true,
      'disabled': data.controlsDisabled
    }"
    >
      <p-checkbox
        class="bfx-checkbox-bold-sm bfx-checkbox-bold-unsized"
        [label]="data.labels.fillAllRemaining"
        [binary]="true"
        [readonly]="true"
        [(ngModel)]="fillRemaining"
      >
      </p-checkbox>
      <!-- not currently used --->
      <div class="fill-amount-container">
        <p-radioButton
          class="bfx-radiobutton-bold fill-amount-radio"
          [label]="data.labels.fillAmount"
          [(ngModel)]="data.fillType"
          value="{{FILL_AMOUNT_PARTIAL}}"
          name="fillNow"
          [disabled]="data.controlsDisabled"
          (ngModelChange)="onFillTypeChange($event)"
        >
        </p-radioButton>
        <bfx-amount-spinner
          #inputOrderAmount
          [disabled]="data.controlsDisabled || data.fillType == FILL_AMOUNT_FULL"
          class="fill-amount-spinner"
          label
          [currency]="data.fixedCcy"
          [(ngModel)]="data.fillAmount"
          (ngModelChange)="onOrderAmountChange($event)"
          (blur)="onOrderAmountBlur($event)"
          [max]="data.maxAmount"
          [min]="data.minAmount"
          [mandatory]="true"
          size="sm"
        >
        </bfx-amount-spinner>
      </div>
    </div>
    <bfx-callout
      [calloutType]="data.callout_type"
      [calloutSize]="data.callout_size"
      [message]="data.callout_message"
      [tooltip]="data.callout_tooltip"
    >
    </bfx-callout>
  </div>
  <div class="divider"></div>
  <div class="blotter-dialog-footer">
    <div class="flex-spacer"></div>
    <div class="action-button-group">
      <button
        *ngIf="data.buttons.visible.close"
        [disabled]="!data.buttons.enabled.close"
        pButton
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="onClose()"
        [label]="data.buttons.labels.close"
      ></button>
      <button
        *ngIf="data.buttons.visible.submit"
        [disabled]="!data.buttons.enabled.submit"
        pButton
        type="button"
        class="bfx-button-primary"
        (click)="onSubmit()"
        [label]="data.buttons.labels.submit"
      ></button>
      <button
        *ngIf="data.buttons.visible.edit"
        [disabled]="!data.buttons.enabled.edit"
        pButton
        type="button"
        class="bfx-button-primary"
        (click)="onEdit()"
        [label]="data.buttons.labels.edit"
      ></button>
      <button
        *ngIf="data.buttons.visible.reject"
        [disabled]="!data.buttons.enabled.reject"
        pButton
        type="button"
        class="bfx-button-negative"
        (click)="onReject()"
        [label]="data.buttons.labels.reject"
      ></button>
      <button
        *ngIf="data.buttons.visible.accept"
        [disabled]="!data.buttons.enabled.accept"
        pButton
        type="button"
        class="bfx-button-primary"
        (click)="onAccept()"
        [label]="data.buttons.labels.accept"
      ></button>
    </div>
  </div>
</div>
